setTimeout(function(){
    var reviewStars = document.querySelectorAll('.yotpo-custom');
    var reviewStarsCountText = document.querySelectorAll('.yotpo-custom .text-m');
  
    for (let i = 0; i < reviewStarsCountText.length; i++) {
  
      var content = reviewStarsCountText[i].innerHTML;
      var indexOfSpace = content.indexOf(' ');
      var reviewsNum = '('+ content.substring(0,indexOfSpace) + ')';
      reviewStarsCountText[i].innerHTML = reviewsNum;
    }
    for (let a = 0; a < reviewStars.length; a++) {
      reviewStars[a].style.display = 'flex';
    }
}, 5000);